module.exports = __webpack_public_path__ + "static/media/line.d6ce818d.svg";